import config from 'config';
import sfax from 'sfax';

sfax.baseUrl = '';

const { domain } = config;

export default {
	getHome400: payload => sfax({
		url: '/api/400',
		type: 'get',
        contentType: 'application/json',
        data: payload
	}),
    getFeedbackContact: payload => sfax({
        url: `/baseApi/getContactPerson`,
        type: 'get',
        contentType: 'application/json',
        data: payload
    }),

    submitFeedback: payload => sfax({
        url: `/baseApi/feedback`,
        type: 'get',
        data: payload
    })
};



// WEBPACK FOOTER //
// ./src/model/api/feedback.js